"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NoTargetFoundError", {
    enumerable: true,
    get: function() {
        return NoTargetFoundError;
    }
});
const NoTargetFoundError = new Error("No target found");
